/**
 * ULD统计分析模块常量定义
 * 包含图表配置、颜色主题、统计类型等
 */

// 统计图表类型
export const CHART_TYPES = {
    PIE: 'pie',
    BAR: 'bar',
    LINE: 'line',
    AREA: 'area',
    COLUMN: 'column',
    DONUT: 'donut',
};

// ULD状态颜色映射（与管理模块保持一致）
export const ULD_STATUS_COLORS = {
    AVL: '#52c41a',     // 可用 - 绿色
    SRV: '#1890ff',     // 受限可用 - 蓝色
    UNS: '#faad14',     // 不可用 - 黄色
    DMG: '#ff7875',     // 损坏 - 浅红色
    HLD: '#fa8c16',     // 留置/隔离 - 橙色
    MNT: '#722ed1',     // 维修中 - 紫色
    SLV: '#13c2c2',     // 可修复/待回收 - 青色
    SCR: '#ff4d4f',     // 已报废 - 红色
    LOST: '#eb2f96',    // 丢失 - 品红色
    OOS: '#ff4d4f',     // 停用 - 红色
    // 向后兼容的别名
    DAM: '#ff7875',     // 损坏别名
    RIP: '#722ed1',     // 维修中别名
};

// ULD状态标签映射
export const ULD_STATUS_LABELS = {
    AVL: '可用',
    SRV: '受限可用',
    UNS: '不可用',
    DMG: '损坏',
    HLD: '留置/隔离',
    MNT: '维修中',
    SLV: '可修复/待回收',
    SCR: '已报废',
    LOST: '丢失',
    OOS: '停用',
    // 向后兼容的别名
    DAM: '损坏',
    RIP: '维修中',
};

// 位置类型颜色映射
export const LOCATION_TYPE_COLORS = {
    AIRPORT: '#52c41a',         // 机场 - 绿色
    FLIGHT: '#1890ff',          // 航班 - 蓝色
    OTHER_LOCATION: '#faad14',  // 其他位置 - 黄色
};

// 位置类型标签映射
export const LOCATION_TYPE_LABELS = {
    AIRPORT: '机场',
    FLIGHT: '航班运输中',
    OTHER_LOCATION: '其他位置',
};

// ULD类型颜色映射
export const ULD_TYPE_COLORS = {
    AKE: '#1890ff',    // 蓝色
    AKH: '#52c41a',    // 绿色
    AKC: '#faad14',    // 黄色
    AGA: '#722ed1',    // 紫色
    PMC: '#fa8c16',    // 橙色
    PAG: '#13c2c2',    // 青色
    PAJ: '#eb2f96',    // 品红色
    PYB: '#2f54eb',    // 深蓝色
    PLA: '#f759ab',    // 深粉色
};

// 所有权类型颜色映射
export const OWNERSHIP_TYPE_COLORS = {
    '自有': '#52c41a',    // 绿色
    '租赁': '#1890ff',    // 蓝色
};

// 图表默认配置
export const DEFAULT_CHART_CONFIG = {
    // 饼图配置
    pie: {
        angleField: 'value',
        colorField: 'type',
        radius: 0.8,
        innerRadius: 0.6,
        label: {
            type: 'inner',
            offset: '-30%',
            content: '{percentage}',
            style: {
                fontSize: 14,
                textAlign: 'center',
            },
        },
        legend: {
            position: 'bottom',
        },
        interactions: [
            { type: 'element-active' },
            { type: 'pie-legend-active' },
        ],
    },
    
    // 柱状图配置
    column: {
        xField: 'type',
        yField: 'value',
        label: {
            position: 'middle',
            style: {
                fill: '#FFFFFF',
                opacity: 0.6,
            },
        },
        meta: {
            type: {
                alias: '类型',
            },
            value: {
                alias: '数量',
            },
        },
    },
    
    // 条形图配置
    bar: {
        xField: 'value',
        yField: 'type',
        seriesField: 'type',
        label: {
            position: 'middle',
            style: {
                fill: '#FFFFFF',
                opacity: 0.6,
            },
        },
    },
};

// 统计卡片配置
export const STATISTICS_CARDS = [
    {
        key: 'total',
        title: 'ULD总数',
        icon: 'DatabaseOutlined',
        color: '#1890ff',
        dataKey: 'total_count',
    },
    {
        key: 'usable',
        title: '可用数量',
        icon: 'CheckCircleOutlined',
        color: '#52c41a',
        dataKey: 'usable_count',
    },
    {
        key: 'unusable',
        title: '不可用数量',
        icon: 'ExclamationCircleOutlined',
        color: '#ff4d4f',
        dataKey: 'unusable_count',
    },
    {
        key: 'utilization',
        title: '利用率',
        icon: 'PieChartOutlined',
        color: '#722ed1',
        dataKey: 'utilization_rate',
        suffix: '%',
    },
];

// 时间范围选项
export const TIME_RANGE_OPTIONS = [
    { label: '今天', value: 'today' },
    { label: '最近7天', value: 'week' },
    { label: '最近30天', value: 'month' },
    { label: '最近90天', value: 'quarter' },
    { label: '自定义', value: 'custom' },
];

// 机场筛选选项 - 已移除，现在使用动态获取的机场数据 (useAirports hook)

// 导出配置
export const EXPORT_OPTIONS = {
    formats: ['PNG', 'PDF', 'Excel'],
    defaultFormat: 'PNG',
    quality: 1,
    backgroundColor: '#ffffff',
};

// ULD核心状态选项
export const ULD_CORE_STATUS_OPTIONS = [
    {
        label: '在库',
        value: 'IN_STOCK',
        color: 'green',
        description: '物理位置在某个机场，处于可用或维护状态'
    },
    {
        label: '在途',
        value: 'IN_TRANSIT',
        color: 'blue',
        description: '正在运输过程中，包括航班运输或其他交通工具'
    },
    {
        label: '停用',
        value: 'OUT_OF_SERVICE',
        color: 'orange',
        description: '暂时停止使用，需要维修或检查'
    },
    {
        label: '退役',
        value: 'RETIRED',
        color: 'red',
        description: '永久停止使用，已从服务中移除'
    },
    {
        label: '丢失',
        value: 'LOST',
        color: 'purple',
        description: '已确认找不到，等待找回或后续处置'
    },
];

// ULD可用性选项
export const ULD_AVAILABILITY_OPTIONS = [
    {
        label: '可用',
        value: 'AVAILABLE',
        color: 'green',
        description: '可以立即投入使用'
    },
    {
        label: '占用',
        value: 'OCCUPIED',
        color: 'orange',
        description: '已被分配给特定任务或航班'
    },
    {
        label: '不可用',
        value: 'UNSERVICEABLE',
        color: 'red',
        description: '无法提供服务，需要修理或更换'
    },
];

// 核心状态颜色映射
export const ULD_CORE_STATUS_COLORS = {
    'IN_STOCK': '#52c41a',          // 在库 - 绿色
    'IN_TRANSIT': '#1890ff',        // 在途 - 蓝色
    'OUT_OF_SERVICE': '#faad14',    // 停用 - 橙色
    'RETIRED': '#ff4d4f',           // 退役 - 红色
    'LOST': '#722ed1',              // 丢失 - 紫色
};

// 可用性颜色映射
export const ULD_AVAILABILITY_COLORS = {
    'AVAILABLE': '#52c41a',      // 可用 - 绿色
    'OCCUPIED': '#faad14',       // 占用 - 橙色
    'UNSERVICEABLE': '#ff4d4f',  // 不可用 - 红色
};

// 核心状态标签映射
export const ULD_CORE_STATUS_LABELS = {
    'IN_STOCK': '在库',
    'IN_TRANSIT': '在途',
    'OUT_OF_SERVICE': '停用',
    'RETIRED': '退役',
    'LOST': '丢失',
};

// 可用性标签映射
export const ULD_AVAILABILITY_LABELS = {
    'AVAILABLE': '可用',
    'OCCUPIED': '占用',
    'UNSERVICEABLE': '不可用',
};

// 统计卡片配置
export const V3_STATISTICS_CARDS = [
    {
        key: 'total',
        title: 'ULD总数',
        icon: 'AppstoreOutlined',
        color: '#1890ff',
        dataKey: 'total_count',
        description: '系统中所有ULD的总数量'
    },
    {
        key: 'available',
        title: '可用数量',
        icon: 'CheckCircleOutlined',
        color: '#52c41a',
        dataKey: 'available_count',
        description: '可立即使用'
    },
    {
        key: 'occupied',
        title: '占用数量',
        icon: 'ExclamationCircleOutlined',
        color: '#faad14',
        dataKey: 'occupied_count',
        description: '已被占用'
    },
    {
        key: 'unserviceable',
        title: '不可用数量',
        icon: 'CloseCircleOutlined',
        color: '#ff4d4f',
        dataKey: 'unserviceable_count',
        description: '无法提供服务'
    },
];

// 状态分析指标
export const V3_ANALYSIS_METRICS = {
    // 核心状态健康度指标
    core_status_health: {
        healthy: ['IN_STOCK', 'IN_TRANSIT'],    // 健康状态
        warning: ['OUT_OF_SERVICE'],            // 警告状态
        critical: ['RETIRED'],                  // 危险状态
    },
    
    // 可用性效率指标
    availability_efficiency: {
        efficient: ['AVAILABLE'],               // 高效状态
        working: ['OCCUPIED'],                  // 工作状态
        inefficient: ['UNSERVICEABLE'],        // 低效状态
    },
    
    // 业务健康度阈值
    health_thresholds: {
        excellent: 90,  // 优秀：>90%
        good: 75,       // 良好：75-90%
        warning: 60,    // 警告：60-75%
        critical: 60,   // 危险：<60%
    },
};

// 默认分页配置
export const DEFAULT_PAGINATION = {
    current: 1,
    pageSize: 20,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条记录`,
};

/**
 * ULD统计页面相关常量
 */

// ULD状态映射
export const ULD_STATUS_MAP = {
    'IN_STOCK': { text: '在库', color: 'green' },
    'IN_TRANSIT': { text: '在途', color: 'blue' },
    'OUT_OF_SERVICE': { text: '停用', color: 'orange' },
    'RETIRED': { text: '退役', color: 'red' },
    'LOST': { text: '丢失', color: 'purple' },
};

// ULD可用性映射
export const ULD_AVAILABILITY_MAP = {
    'AVAILABLE': { text: '可用', color: 'green' },
    'OCCUPIED': { text: '占用', color: 'blue' },
    'UNSERVICEABLE': { text: '不可用', color: 'red' },
}; 